/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-20",
    versionChannel: "nightly",
    buildDate: "2025-04-20T00:07:01.503Z",
    commitHash: "b3bd10877bcb607b460de47b4ff741b15dacb302",
};
